import React, { useEffect } from "react";
import RegisterForm from "../components/RegisterForm";
import ActionButton from "../components/ActionButton";
import { useTranslate } from "../components/TranslationText";
import { updateHeadTags } from "../helper/updateHeadTags";
import axiosUmbraco from '../../src/axios/axiosUmbraco';

const ergisterPageId = process.env.REACT_APP_UMBRACO_REGISTRATION_PAGE_SEO;

export default function RegisterPage() {
  const { translate } = useTranslate();

  async function getSeo() {
    const seo = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content/item/?id=${ergisterPageId}`,);
    if (seo?.data?.length > 0) {
      const seoData = seo.data[0].properties;
      updateHeadTags({
        keywords: seoData?.seoKeywords,
        description: seoData?.seoDescription,
        title: seoData?.seoTitle,
      })
    }
  }
  useEffect(() => {
    getSeo();
  }, [])


  return (
    <>
      <div className="row rtl ">
        <div className="col-lg-12 col-md-12 col-sm-12 rtl">
          <div className="col-sm-12 rtl p0">
            <div className="col-lg-3 col-md-3 col-sm-12 ">
              <ActionButton
                margin={5}
                width={"100%"}
                key={"signupuaepass"}
                text={"Sign in With UAE PASS"}
                type={"signupuaepass"}
              />
            </div>
            {/* <div className="UaePassSeperator">
              <div className="Seperator" ></div>
              <span className="uaepassor">{translate('web.or', 'OR')}</span>
            </div> */}
          </div>
          <div className="Seperator w-100 mt-2 mb-5" ></div>
          <h2 className="fw-bold mb-main">{translate('web.registerNewAccount', 'Register New Account')}</h2>
          <RegisterForm />
        </div>
      </div>
    </>
  );
}
